// ColliXL-logoen som vektor, i lyst og mørkt tema. Samme geometri som på
// nettsiden (collixl-web, src/components/Logo.tsx): merket er firerings-C-en
// fra lasteikonet (public/brand/colliloader.svg), og ordmerket er tegnet etter
// målene på det offisielle ordmerket, så det er skarpt i alle størrelser.
//
// PNG-ordmerket hadde mørkegrønn «COLLI», som nesten forsvant på den mørke
// menyen. Med `tema="dark"` løftes fargene, som på nettsiden.

const RINGFARGER = {
  paaLys: ['#285020', '#307838', '#58a040', '#88c038'],
  // Den mørkeste ringen forsvinner mot nesten svart; hele settet løftes ett trinn.
  paaMork: ['#3f7a33', '#4f9a44', '#74b157', '#9fcd55'],
}

const ORDFARGER = {
  paaLys: { base: '#285020', aksent: '#58a040' },
  paaMork: { base: '#ffffff', aksent: '#9fcd55' },
}

/** En bue med åpning mot høyre: halv åpningsvinkel i grader. */
function bue(cx, cy, r, halvVinkel) {
  const a = (halvVinkel * Math.PI) / 180
  const x = (cx + r * Math.cos(a)).toFixed(2)
  const y1 = (cy - r * Math.sin(a)).toFixed(2)
  const y2 = (cy + r * Math.sin(a)).toFixed(2)
  return `M ${x} ${y1} A ${r} ${r} 0 1 0 ${x} ${y2}`
}

// Merket, tegnet i en boks på 224 enheter.
const RADIER = [94, 81, 68, 55]

function Ringer({ farger }) {
  return (
    <g fill="none" strokeWidth={10.5} strokeLinecap="round">
      {RADIER.map((r, i) => <path key={r} d={bue(112, 112, r, 34)} stroke={farger[i]} />)}
    </g>
  )
}

// Ordmerket i en boks på 20 enheters høyde (runde bokstaver 0–20, rette
// bokstaver korrigert til 0,65–19,35). Bredde ≈ 122,9.
const S = 5.16 // strekbredde
const T = 0.65 // innrykk for flate bokstaver (runde bokstaver går litt utenfor)
const R = 10 - S / 2 // radius midt i streken for C og O

function Lbokstav({ x0, farge }) {
  return <path d={`M ${x0} ${T} H ${x0 + S} V ${20 - T - S} H ${x0 + 13.55} V ${20 - T} H ${x0} Z`} fill={farge} />
}

function Ordmerke({ farger }) {
  const { base, aksent } = farger
  const xX = 87.1
  const xb = 18.71
  const t = 5.8
  return (
    <g>
      <path d={bue(10, 10, R, 35)} stroke={base} strokeWidth={S} fill="none" />
      <circle cx={30} cy={10} r={R} stroke={base} strokeWidth={S} fill="none" />
      <Lbokstav x0={43.55} farge={base} />
      <Lbokstav x0={60.97} farge={base} />
      <rect x={78.06} y={T} width={S} height={20 - 2 * T} fill={base} />
      <path
        d={`M ${xX} ${T} H ${xX + t} L ${xX + xb} ${20 - T} H ${xX + xb - t} Z M ${xX + xb - t} ${T} H ${xX + xb} L ${xX + t} ${20 - T} H ${xX} Z`}
        fill={aksent}
      />
      <Lbokstav x0={109.35} farge={aksent} />
    </g>
  )
}

const variant = tema => (tema === 'dark' ? 'paaMork' : 'paaLys')

/** Ordmerket «COLLIXL». `tema`: 'light' | 'dark' (temaet i ThemeContext). */
export function LogoOrdmerke({ tema = 'light', className = '', tittel = 'ColliXL' }) {
  return (
    <svg viewBox="-0.5 -0.5 124 21" className={className} role="img" aria-label={tittel}>
      <Ordmerke farger={ORDFARGER[variant(tema)]} />
    </svg>
  )
}

/** Merket alene: firerings-C-en. */
export function LogoMerke({ tema = 'light', className = '', tittel = 'ColliXL' }) {
  return (
    <svg viewBox="8 8 192 208" className={className} role="img" aria-label={tittel}>
      <Ringer farger={RINGFARGER[variant(tema)]} />
    </svg>
  )
}
